module.exports = __webpack_public_path__ + "img/bk_08.ebed6973.png";